import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { getBase64ImageFromUrl } from '../utils/urlToBase64.js'

export const pdfMixin = {
  data: () => ({}),
  methods: {
    downloadParentQR(parent, sizeQr) {
      var images = [];
      var size = sizeQr
      var siceColsAndRows = size + 20
      var doc = new jsPDF('p', 'pt', 'letter');
      doc.autoTable({
        head: [
          ['QR', 'Nombre', 'Apellidos', 'Email']
        ],
        body: [
          [null, parent.firstName, parent.lastName, parent.mail],
          // ...
        ],
        margin: {
          right: 50,
          left: 50
        },
        tableWidth: 500,
        styles: {
          overflow: 'linebreak',
          cellWidth: 'wrap'
        },
        columnStyles: {
          0: {
            cellWidth: siceColsAndRows
          }
        },
        willDrawCell: function (data) {

          data.cell.height = siceColsAndRows
          data.cell.contentHeight = siceColsAndRows
          data.cell.halign = 'center'

        },
        didDrawCell: function (data) {
          console.log(data)
          if (data.column.dataKey == 0 && data.section == 'body') {
            images.push({
              elem: parent.qr,
              x: data.cell.textPos ? data.cell.textPos.x : data.cell.x,
              y: data.cell.textPos ? data.cell.textPos.y : data.cell.y
            });
          }
        },
        /*didDrawCell: data => {
            console.log(data)
            if (data.section == 'body' && data.column.index == 0) {
                doc.addImage(parent.qr, 'JPEG',  parseInt(data.cell.x), parseInt(data.cell.y), 100, 100)
            }
        },*/
        didDrawPage: function () {
          for (var i = 0; i < images.length; i++) {
            if (!images[i].isLoad) {
              doc.addImage(images[i].elem, "JPEG", images[i].x + 10, images[i].y + 5, size, size);
              images[i].isLoad = true;
            }
          }
        }
      });

      doc.save("example.pdf");
    },
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    downloadStudentMasiveQR(studentsInput, sizeQr, branch, space) {
      var byGroup = {};
      var students = studentsInput || [];
      var getFirst = function(value) {
        var sg = (value || "").split(" ").filter(function(s) {
          return !!s;
        }).map(function(s) {
          return s.toUpperCase();
        });

        if (sg.length) {
          return sg[0];
        }
        return value;
      };

      students.forEach(function(student) {
        if (space == true) {
          var group =  null;
          if (!byGroup[group]) {
            byGroup[group] = [];
          }
          student.firstName = getFirst(student.firstName);
          student.lastName = getFirst(student.lastName);
          byGroup[group].push(student);
        } else {
          var group =  student.level.typeLevel + ' ' + student.gg.grade + student.gg.group;
          if (!byGroup[group]) {
            byGroup[group] = [];
          }
          student.firstName = getFirst(student.firstName);
          student.lastName = getFirst(student.lastName);
          byGroup[group].push(student);
        }
      });

      var isSmall = sizeQr === 120;
      var head = ['', '', ''];
      var bodyArray = [];
      var placeholders = [];
      var rowsPerPage = isSmall ? 4 : 3;

      var keys = Object.keys(byGroup).sort();
      keys.forEach(function(group) {
        var row = [];
        var rowCounter = 0;
        var items = byGroup[group].sort(function(a, b) {
          if(a.firstName < b.firstName) { return -1; }
          if(a.firstName > b.firstName) { return 1; }

          if(a.lastName < b.lastName) { return -1; }
          if(a.lastName > b.lastName) { return 1; }
            
          return 0;
        });
          
        items.forEach(function(student) {
          row.push({
            personId: student.personId,
            firstName: student.firstName,
            lastName: student.lastName,
            levelGroup: student.level.typeLevel, 
            levelGroup: student.level.typeLevel,
            grade: student.gg.grade,
            group: student.gg.grade + student.gg.group,
            group1: student.gg.group,
            image: student.qr
          });

          if (row.length === head.length) {
            ++rowCounter;
            bodyArray.push(row);
            placeholders.push(head);
            row = [];
          }
        });

        if (row.length > 0 || (rowCounter % rowsPerPage) !== 0) {
          bodyArray.push(head.map(function(_, i) {
            return row[i] || false
          }));
          placeholders.push(head);
        }
      });

      var cellHeaderX = isSmall ? 45 : 80;
      var cellHeaderY = isSmall ? 45 : 70;
      var cellWidth = 180;
      var qrWidth = isSmall ? 135 : 180;
      var offset = isSmall ? 12 : 15;
      var cellHeight = cellHeaderY + qrWidth + offset;
      var branchImage = branch && branch.img ? "data:image/jpg;base64, " + branch.img : "";

      var qrSize = qrWidth + offset;
      var increment = isSmall ? 10 : 10;
      var offsetX = cellHeaderX;
      var branchImageSize = isSmall ? 40 : 60;
      
      if (!branchImage) {
        offsetX = 0;
      }
      
      var maxTextWidth = cellWidth - offsetX;
      var doc = new jsPDF('p', 'pt', 'letter');
      doc.autoTable({
        head: [head],
        theme : "plain",
        body: placeholders,
        margin: {
          right: 35,
          left: 35,
          top: 20,
          bottom: 20
        },
        showHead: false,
        showFoot: false,
        tableWidth: 600,
        styles: {
          overflow: 'linebreak',
          valign : 'top'
        },
        rowPageBreak : 'avoid',
        pageBreak : 'avoid',
        columnStyles: {
          0: {
            cellWidth: cellWidth + 10,
            overflow: 'linebreak'
          },
          1: {
            cellWidth: cellWidth + 10,
            overflow: 'linebreak'
          },
          2: {
            cellWidth: cellWidth,
            overflow: 'linebreak'
          }
        },
        willDrawCell: function (data) {
          if (data.section === 'body') {
            var student = bodyArray[data.row.index][data.column.index];
            var ch = cellHeight;
            var t = typeof student;

            if (t !== "object") {
              ch = 1000;
            }
            data.cell.height = ch;
            data.cell.contentHeight = ch;
            data.row.maxCellHeight = ch;
            data.row.height = ch;
          }
        },
        didDrawCell: function (data) {
          var student = bodyArray[data.row.index][data.column.index];
          if (typeof student === "object") {
            if (student.image) {
              doc.addImage(student.image, "PNG", data.cell.x - offset, data.cell.y + cellHeaderY, qrSize, qrSize);
            }
            if (branchImage) {
              doc.addImage(branchImage, "JPEG", data.cell.x, data.cell.y, branchImageSize, branchImageSize);
            }

            var y = data.cell.y;
            var tx = data.cell.x + offsetX;

            doc.text(student.firstName, tx, y+=increment, { maxWidth: maxTextWidth });
            doc.text(student.lastName, tx, y+=increment, { maxWidth: maxTextWidth });
            doc.text(student.levelGroup, tx, y+=increment, { maxWidth: maxTextWidth });
            if (student.grade.length < 7) {
              doc.text(student.group, tx, y+=increment, { maxWidth: maxTextWidth });
            } else {
              doc.text(student.group1, tx, y+=increment, { maxWidth: maxTextWidth });
            }
            doc.text(student.personId, tx, y+=increment, { maxWidth: maxTextWidth });
          }
        },
      });
      doc.save("qrs-estudiantes.pdf");
    },

    async downloadParentMasiveQR(parentsInput, sizeQr, branch) {
      var parents = parentsInput || [];
      var getFirst = function(value) {
        var sg = (value || "").split(" ").filter(function(s) {
          return !!s;
        }).map(function(s) {
          return s.toUpperCase();
        });

        if (sg.length) {
          return sg[0];
        }
        return value;
      };

      parents.forEach(function(parent) {
        parent.firstName = getFirst(parent.firstName);
        parent.lastName = getFirst(parent.lastName);
      });

      var isSmall = sizeQr === 120;
      var head = ['', '', ''];
      var bodyArray = [];
      var rowsPerPage = isSmall ? 4 : 3;
      var rowCounter = 0;
      var row = [], placeholders = [];

      parents.forEach(function(parent) {
        row.push({
          firstName: parent.firstName,
          lastName: parent.lastName,
          image: parent.qr,
        });

        if (row.length === head.length) {
          ++rowCounter;
          bodyArray.push(row);
          placeholders.push(head);
          row = [];
        }
      });
      
      if (row.length > 0 || (rowCounter % rowsPerPage) !== 0) {
        bodyArray.push(head.map(function(_, i) {
          return row[i] || false
        }));
        placeholders.push(head);
      }

      var cellHeaderX = isSmall ? 60 : 80;
      var cellHeaderY = isSmall ? 40 : 50;
      var cellWidth = 180;
      var qrWidth = isSmall ? 135 : 180;
      var offset = isSmall ? 15 : 20;
      var cellHeight = cellHeaderY + qrWidth + offset;
      const branchImage = branch && branch.imageStorage && branch.imageStorage.miniObjUrl ? await getBase64ImageFromUrl(branch.imageStorage.miniObjUrl) : "";

      var qrSize = qrWidth + offset;
      var increment = isSmall ? 10 : 12;
      var offsetX = cellHeaderX;
      var branchImageSize = isSmall ? 40 : 60;
      
      if (!branchImage) {
        offsetX = 0;
      }
      
      var maxTextWidth = cellWidth - offsetX;
      var doc = new jsPDF('p', 'pt', 'letter');
      doc.autoTable({
        head: [head],
        theme : "plain",
        body: placeholders,
        margin: {
          right: 35,
          left: 35,
          top: 20,
          bottom: 20
        },
        showHead: false,
        showFoot: false,
        tableWidth: 600,
        styles: {
          overflow: 'linebreak',
          valign : 'top'
        },
        rowPageBreak : 'avoid',
        pageBreak : 'avoid',
        columnStyles: {
          0: {
            cellWidth: cellWidth + 10,
            overflow: 'linebreak'
          },
          1: {
            cellWidth: cellWidth + 10,
            overflow: 'linebreak'
          },
          2: {
            cellWidth: cellWidth,
            overflow: 'linebreak'
          }
        },
        willDrawCell: function (data) {
          if (data.section === 'body') {
            data.cell.height = cellHeight;
            data.cell.contentHeight = cellHeight;
            data.row.maxCellHeight = cellHeight;
            data.row.height = cellHeight;
          }
        },
        didDrawCell: function (data) {
          var parent = bodyArray[data.row.index][data.column.index];
          if (typeof parent === "object") {
            if (parent.image) {
              doc.addImage(parent.image, "PNG", data.cell.x - offset, data.cell.y + cellHeaderY, qrSize, qrSize);
            }
            if (branchImage) {
              doc.addImage(branchImage, "JPEG", data.cell.x, data.cell.y, branchImageSize, branchImageSize);
            }

            var y = data.cell.y;
            var tx = data.cell.x + offsetX;

            doc.text(parent.firstName, tx, y+=increment, { maxWidth: maxTextWidth });
            doc.text(parent.lastName, tx, y+=increment, { maxWidth: maxTextWidth });
          }
        },
      });
      doc.save("qrs-tutores.pdf");
    },

    async downloadEmployeeMasiveQR(employeesInput, sizeQr, branch, space) {
      var byrol = {};
      var employees = employeesInput || [];
      var getFirst = function(value) {
        var sg = (value || "").split(" ").filter(function(s) {
          return !!s;
        }).map(function(s) {
          return s.toUpperCase();
        });

        if (sg.length) {
          return sg[0];
        }
        return value;
      };

      employees.forEach(function(employee) {
        if (space == true) {
          var rol =  null;
          if (!byrol[rol]) {
            byrol[rol] = [];
          }
          employee.firstName = getFirst(employee.firstName);
          employee.lastName = getFirst(employee.lastName);
          byrol[rol].push(employee)
        } else {
          var rol = employee.webRole.name;
          if (!byrol[rol]) {
            byrol[rol] = [];
          }
          employee.firstName = getFirst(employee.firstName);
          employee.lastName = getFirst(employee.lastName);
          byrol[rol].push(employee)
        }
      });

      var isSmall = sizeQr === 120;
      var head = ['', '', ''];
      var bodyArray = [];
      var placeholders = [];
      var rowsPerPage = isSmall ? 4 : 3;
      
      var keys = Object.keys(byrol).sort();
      keys.forEach(function(rol) {
        var row = [];
        var rowCounter = 0;
        var items = byrol[rol].sort(function(a, b) {
          if(a.firstName < b.firstName) { return -1; }
          if(a.firstName > b.firstName) { return 1; }

          if(a.lastName < b.lastName) { return -1; }
          if(a.lastName > b.lastName) { return 1; }
            
          return 0;
        });

        items.forEach(function(employee) {
          row.push({
            firstName: employee.firstName,
            lastName: employee.lastName,
            role: employee.webRole.name,
            image: employee.qr,
          });

          if (row.length === head.length) {
            ++rowCounter;
            bodyArray.push(row);
            placeholders.push(head);
            row = [];
          }
        });
      
        if (row.length > 0 || (rowCounter % rowsPerPage) !== 0) {
          bodyArray.push(head.map(function(_, i) {
            return row[i] || false
          }));
          placeholders.push(head);
        }
      });

      var cellHeaderX = isSmall ? 45 : 80;
      var cellHeaderY = isSmall ? 40 : 55;
      var cellWidth = 185;
      var qrWidth = isSmall ? 135 : 185;
      var offset = isSmall ? 12 : 15;
      var cellHeight = cellHeaderY + qrWidth + offset;
      const branchImage = branch && branch.imageStorage && branch.imageStorage.miniObjUrl ? await getBase64ImageFromUrl(branch.imageStorage.miniObjUrl) : "";

      var qrSize = qrWidth + offset;
      var increment = isSmall ? 10 : 10;
      var offsetX = cellHeaderX;
      var branchImageSize = isSmall ? 40 : 60;
      
      if (!branchImage) {
        offsetX = 0;
      }
      
      var maxTextWidth = cellWidth - offsetX;
      var doc = new jsPDF('p', 'pt', 'letter');
      doc.autoTable({
        head: [head],
        theme : "plain",
        body: placeholders,
        margin: {
          right: isSmall ? 35: 30,
          left: isSmall ? 35: 30,
          top: 20,
          bottom: 20
        },
        showHead: false,
        showFoot: false,
        tableWidth: 600,
        styles: {
          overflow: 'linebreak',
          valign : 'top'
        },
        rowPageBreak : 'avoid',
        pageBreak : 'avoid',
        columnStyles: {
          0: {
            cellWidth: cellWidth + 10,
            overflow: 'linebreak'
          },
          1: {
            cellWidth: cellWidth + 10,
            overflow: 'linebreak'
          },
          2: {
            cellWidth: cellWidth,
            overflow: 'linebreak'
          }
        },
        willDrawCell: function (data) {
          if (data.section === 'body') {
            var employee = bodyArray[data.row.index][data.column.index];
            var ch = cellHeight;
            var t = typeof employee;

            if (t !== "object") {
              ch = 1000;
            }
            data.cell.height = ch;
            data.cell.contentHeight = ch;
            data.row.maxCellHeight = ch;
            data.row.height = ch;
          }
        },
        didDrawCell: function (data) {
          var employee = bodyArray[data.row.index][data.column.index];
          if (typeof employee === "object") {
            if (employee.image) {
              doc.addImage(employee.image, "PNG", data.cell.x - offset, data.cell.y + cellHeaderY, qrSize, qrSize);
            }
            if (branchImage) {
              doc.addImage(branchImage, "JPEG", data.cell.x, data.cell.y, branchImageSize, branchImageSize);
            }

            var y = data.cell.y;
            var tx = data.cell.x + offsetX;

            doc.text(employee.firstName, tx, y+=increment, { maxWidth: maxTextWidth });
            doc.text(employee.lastName, tx, y+=increment, { maxWidth: maxTextWidth });
            doc.text(employee.role, tx, y+=increment, { maxWidth: maxTextWidth });
          }
        },
      });
      doc.save("qrs-colaboradores.pdf");
    },
    
    downloadThirdQR(parent, sizeQr) {
      var images = [];
      var size = sizeQr
      var siceColsAndRows = size + 20
      var doc = new jsPDF('p', 'pt', 'letter');
      doc.autoTable({
        head: [
          ['QR', 'Nombre', 'Fecha', 'Teléfono']
        ],
        body: [
          [null, parent.firstName + " " + parent.lastName, parent.date, parent.phone],
          // ...
        ],
        margin: {
          right: 50,
          left: 50
        },
        tableWidth: 500,
        styles: {
          overflow: 'linebreak',
          cellWidth: 'wrap'
        },
        columnStyles: {
          0: {
            cellWidth: siceColsAndRows
          }
        },
        willDrawCell: function (data) {

          data.cell.height = siceColsAndRows
          data.cell.contentHeight = siceColsAndRows
          data.cell.halign = 'center'

        },
        didDrawCell: function (data) {
          if (data.column.dataKey == 0 && data.section == 'body') {
            images.push({
              elem: parent.qr,
              x: data.cell.textPos ? data.cell.textPos.x : data.cell.x,
              y: data.cell.textPos ? data.cell.textPos.y : data.cell.y
            });
          }
        },
        /*didDrawCell: data => {
            console.log(data)
            if (data.section == 'body' && data.column.index == 0) {
                doc.addImage(parent.qr, 'JPEG',  parseInt(data.cell.x), parseInt(data.cell.y), 100, 100)
            }
        },*/
        didDrawPage: function () {
          for (var i = 0; i < images.length; i++) {
            if (!images[i].isLoad) {
              doc.addImage(images[i].elem, "JPEG", images[i].x + 10, images[i].y + 5, size, size);
              images[i].isLoad = true;
            }
          }
        }
      });

      doc.save("QR.pdf");
    },
  }
}
